import { Action, createReducer, on } from '@ngrx/store';
import * as PlayTournamentActions from './play-tournament.actions';

export const PLAY_TOURNAMENT_FEATURE_KEY = 'play-tournament';

export interface PlayTournamentState {
  selectedId?: string | number; // which PlayTournament record has been selected
  loaded: boolean; // has the PlayTournament list been loaded
  error?: Error | string | null; // last known error (if any)
  startingPlay?: boolean;
  playing?: boolean;
}

export interface PlayTournamentPartialState {
  readonly [PLAY_TOURNAMENT_FEATURE_KEY]: PlayTournamentState;
}

export const initialPlayTournamentState: PlayTournamentState = {
  loaded: false,
  startingPlay: false,
  playing: false,
};

const reducer = createReducer(
  initialPlayTournamentState,
  on(PlayTournamentActions.playTournament, (state) => ({
    ...state,
    loaded: false,
    error: null,
    startingPlay: true,
    playing: false,
  })),
  on(PlayTournamentActions.playTournamentSuccess, (state) => ({
    ...state,
    loaded: false,
    error: null,
    startingPlay: false,
    playing: true,
  })),
  on(PlayTournamentActions.playTournamentFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
    startingPlay: false,
    playing: false,
  })),
);

export function playTournamentReducer(
  state: PlayTournamentState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
